import { useEffect, useState } from "react";
import { usePostOnboardingMutation } from "store/api/apiSlice";
import { OnboardingEventMessageType } from "types/onboarding";
import Intro from "./Intro";
import Review from "./Review";
import Terms from "./Terms";

enum OnboardingStep {
  intro = "intro",
  terms = "terms",
  review = "review",
}

const ONBOARDING_STEPS = [
  OnboardingStep.intro,
  OnboardingStep.terms,
  OnboardingStep.review,
];

const Onboarding = () => {
  const params = new URLSearchParams(window.location.search);
  const embedded = JSON.parse(params.get("embedded"));
  const [currentStep, setCurrentStep] = useState(OnboardingStep.intro);
  const [postOnboarding, { isSuccess }] = usePostOnboardingMutation();

  const emitMessage = (type: OnboardingEventMessageType) => {
    window.parent.postMessage({ type }, "*");
  };

  const onCancel = () => {
    if (embedded) {
      window.parent.postMessage({ type: OnboardingEventMessageType.exit }, "*");
    } else {
      window.location.href = "/";
    }
  };

  const onSuccess = () => {
    emitMessage(OnboardingEventMessageType.success);
  };

  const onComplete = () => {
    emitMessage(OnboardingEventMessageType.exit);

    if (!embedded) {
      window.location.href = "/dashboard";
    }
  };

  const goToNextStep = async () => {
    const currentIndex = ONBOARDING_STEPS.indexOf(currentStep);
    const nextStep = ONBOARDING_STEPS[currentIndex + 1];

    switch (currentStep) {
      case OnboardingStep.intro:
        setCurrentStep(nextStep);
        break;
      case OnboardingStep.terms:
        await postOnboarding({ complete: true });
        setCurrentStep(nextStep);
        break;
      case OnboardingStep.review:
        onComplete();
        if (embedded) await new Promise((_resolve) => null); // On last step, if embedded, show loading state indefinitely
        break;
      default:
    }
  };

  useEffect(() => {
    if (isSuccess) onSuccess();
  }, [isSuccess]);

  const stepProps = { onCancel, goToNextStep, embedded };

  switch (currentStep) {
    case OnboardingStep.intro:
      return <Intro {...stepProps} />;
    case OnboardingStep.terms:
      return <Terms {...stepProps} />;
    case OnboardingStep.review:
      return <Review {...stepProps} />;
    default:
      return null;
  }
};

export default Onboarding;
